import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/research", label: "Research" },
  { to: "/activities", label: "Activities" },
  { to: "/publications", label: "Publications" },
  { to: "/gallery", label: "Gallery" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-[#E35D29]/10 backdrop-blur-xl bg-[#FDFBF7]/80"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 h-20 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <span className="inline-flex h-10 w-10 items-center justify-center bg-[#E35D29] text-white font-serif-display text-xl">
            R
          </span>
          <div className="leading-tight">
            <div className="font-serif-display text-lg font-semibold text-[#1A2456]">Dr. Ruchi Singh</div>
            <div className="text-[10px] tracking-[0.25em] text-[#8A817C] uppercase">Assistant Professor</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `link-underline text-sm tracking-wide ${
                  isActive ? "text-[#E35D29]" : "text-[#2D2825] hover:text-[#E35D29]"
                }`
              }
              end={l.to === "/"}
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-contact"
            className="ml-2 bg-[#1A2456] text-white px-5 py-2.5 text-sm hover:bg-[#10163A] transition-colors"
          >
            Get in Touch
          </Link>
        </nav>

        <button
          data-testid="mobile-menu-toggle"
          className="lg:hidden p-2 text-[#1A2456]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-[#E35D29]/10 bg-[#FDFBF7]">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `py-2 text-base ${isActive ? "text-[#E35D29]" : "text-[#2D2825]"}`
                }
                end={l.to === "/"}
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
